import Accordion from '@components/common/Accordion/Accordion';

import { FaqCategory } from '../../../models/FaqCategory';

export interface FAQCategoriesWithFAQsProps {
  faqCategories: FaqCategory[];
}
const FAQCategoriesWithFAQs = ({
  faqCategories,
}: FAQCategoriesWithFAQsProps) => {
  return (
    <>
      {faqCategories?.map(faqCategory => (
        <div className="mb-8" key={faqCategory.id}>
          <h2 className="mb-8 text-2xl font-light text-center text-coral-100 md:text-3xl">
            {faqCategory.name}
          </h2>
          <div className="max-w-5xl mx-auto">
            {faqCategory.faqs?.map(({ id, question, answer }) => (
              <div key={id} className="mb-5">
                <Accordion
                  btnProps={{
                    className:
                      'border-l-8 bg-grey-5 border-coral-100 flex-grow w-full text-left p-4 flex',
                  }}
                  iconColorClassName="text-coral-100"
                  label={question}
                >
                  <div
                    className="px-4 pt-4"
                    dangerouslySetInnerHTML={{ __html: answer || '' }}
                  />
                </Accordion>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default FAQCategoriesWithFAQs;
